
import { ContactsQuery } from '@/queries/contacts.gql'
import { formatRawMapResponse } from '~/utils/mapHelpers'

export default {
  name: 'Contacts',
  async asyncData({ app, i18n, $config, $sentry, error }) {
    try {
      const {
        data: { contacts },
      } = await app.$gqlQuery({
        query: ContactsQuery,
        fetchPolicy: 'no-cache',
        variables: {
          domainId: $config.domainId,
          languageCode: i18n.locale,
        },
      })
      return {
        contacts: formatRawMapResponse(contacts),
      }
    } catch (ex) {
      $sentry.captureException(`Contact us page on ${$config.domain} error`, ex)
      return error({
        statusCode: 404,
        message: 'SERVER ERROR ON CONTACT US PAGE',
      })
    }
  },
  data() {
    return {
      contacts: [],
      pageData: {},
    }
  },
  computed: {
    offices() {
      return (
        this.contacts[0]?.offices?.slice(0, this.$config.shownOffices) || []
      )
    },
    bgImage() {
      return this.pageData.bgImage?.src || '/images/hero-news.jpg'
    },
    title() {
      return this.pageData.title || this.$t('front.contact_us')
    },
    officeTitle() {
      const title = this.offices[0]?.title_translated || ''
      return title.split(',')[0]
    },
    cards() {
      const translations = []

      for (let index = 1; index <= 4; index++) {
        const titleKey = `front.contacts.card${index}.title`
        const textKey = `front.contacts.card${index}.text`
        const linkKey = `front.contacts.card${index}.link`
        const linkTextKey = `front.contacts.card${index}.linkText`

        if (!this.$te(titleKey) || !this.$te(textKey)) continue

        translations.push({
          title: this.$t(titleKey),
          text: this.$t(textKey),
          link: this.$te(linkKey) ? this.$t(linkKey) : '',
          linkText: this.$te(linkTextKey) ? this.$t(linkTextKey) : '',
        })
      }

      return translations
    },
    cardsGridStyle() {
      switch (this.cards.length) {
        case 2:
          return 'grid gap-6 md:grid-cols-2'
        case 3:
          return 'grid gap-6 md:grid-cols-3'
        case 4:
          return 'grid gap-6 md:grid-cols-2 lg:grid-cols-4'
        default:
          return ''
      }
    },
  },
  mounted() {
    if (!Array.isArray(this.contacts) && this.contacts.length === 0) return
    this.$store.commit(
      'contacts/setOffices',
      this.contacts
        .flatMap((countryItem) => countryItem.offices)
        .map((countryItem) => ({
          id: countryItem.id,
          title: countryItem.title_translated,
          address: countryItem.address_translated,
          value: countryItem.value,
        })),
    )
    if (this.$route.hash === '#contact-form') this.$openContactsModal()
  },
  created() {
    this.pageData = this.$store.state?.page?.content
  },
}
